import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import styles from "./styles";
import useStyles from "@hooks/useStyle";

interface PropsInterface {
	trigger?: JSX.Element;
	children: JSX.Element;
	handleClose: () => void;
}

const CustomModal = (props: PropsInterface) => {
	const { handleClose, children } = props;

	const { classes } = useStyles(styles) as any;

	return (
		<Modal open onClose={handleClose}>
			<Box className={classes.boxRoot}>{children}</Box>
		</Modal>
	);
};

export default CustomModal;
